import { load } from '@fingerprintjs/fingerprintjs'
import { pick } from 'underscore'
import { csrfToken, canReadLocalStorage } from 'helpers/view'
import { isStudent } from 'utils/user'

function componentParameters(result) {
  const params = {
    platform: result.components.platform?.value,
    screenResolution: result.components.screenResolution?.value?.toString(),
    userAgent: navigator.userAgent,
  }

  return pick(params, (value) => value != null)
}

export const recordActivity = ({
  activity_type,
  fingerprint,
  components,
  assessment_item_id,
  assignment_id,
  attempt_id,
  part_id,
}) => {
  fetch('/activities.json', {
    method: 'POST',
    headers: {
      'X-CSRF-Token': csrfToken(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      user_id: _E.currentUser.id,
      activity_type,
      fingerprint,
      components,
      assignment_id,
      assessment_item_id,
      attempt_id,
      part_id,
    }),
  })
}

export const recordStudentActivity = (params) => {
  if (isStudent()) {
    recordActivity(params)
  }
}

export const fingerprint = () => {
  load()
    .then((fp) => fp.get())
    .then((result) => {
      const fingerprint = result.visitorId
      const lastFingerprint =
        canReadLocalStorage() && localStorage.getItem('fingerprint')

      if (fingerprint != lastFingerprint) {
        recordActivity({
          activity_type: 'ui.fingerprint',
          fingerprint,
          components: componentParameters(result),
        })

        try {
          localStorage.setItem('fingerprint', fingerprint)
        } catch {
          // ok to swallow this
        }
      }
    })
}
